import { useTranslation } from "react-i18next";

function YourData() {

  const { t } = useTranslation();

  return (
    <div className="relative pt-[80px] xl:pt-[160px] overflow-hidden">
      <div className="max-w-[1220px] mx-[20px] xl:mx-auto">       
        <div className="flex flex-col xl:flex-row justify-between">
            <div className="xl:w-[600px]">
                <p className="text-[24px] xl:text-[36px] zen-dots leading-[1.2] text-[#1E1C21]">{t('aboutus.23')}</p>
                <p className="text-[12px] xl:text-[14px] text-[#000000B2] ibm-plex xl:max-w-[497px] mt-[20px] xl:mt-[40px] xl:h-[105px]">{t('aboutus.24')}</p>
                <div className="h-[177px] bg-[#F1F1F1] border-[#B8B6B8] border mt-[40px] xl:mt-[30px] px-[20px] pt-[20px] xl:pt-[40px] pb-[20px] xl:pb-0">
                    <div className="flex gap-[8px]">
                        <div className="w-[2px] h-[18px] bg-[#1E1C21] mt-[6px]"></div>
                        <div className="">
                            <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21]">{t('aboutus.27')}</p>
                            <p className="text-[12px] xl:text-[14px] text-[#000000B2] ibm-plex xl:max-w-[540px] mt-[12px]">{t('aboutus.28')}</p>
                        </div>
                    </div>
                </div>
                <div className="h-[177px] bg-[#F1F1F1] border-[#B8B6B8] border mt-[-1px] px-[20px] pt-[20px] xl:pt-[40px] pb-[20px] xl:pb-0">
                    <div className="flex gap-[8px]">
                        <div className="w-[2px] h-[18px] bg-[#1E1C21] mt-[6px]"></div>
                        <div className="">
                            <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21]">{t('aboutus.31')}</p>
                            <p className="text-[12px] xl:text-[14px] text-[#000000B2] ibm-plex xl:max-w-[540px] mt-[12px]">{t('aboutus.32')}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="xl:w-[600px] mt-[120px] xl:mt-0">
                <p className="text-[24px] xl:text-[36px] zen-dots leading-[1.2] text-[#1E1C21]">{t('aboutus.25')}</p>
                <p className="text-[12px] xl:text-[14px] text-[#000000B2] ibm-plex xl:max-w-[497px] mt-[20px] xl:mt-[40px] xl:h-[105px]">{t('aboutus.26')}</p>
                <div className="h-[177px] bg-[#F1F1F1] border-[#B8B6B8] border mt-[40px] xl:mt-[30px] px-[20px] pt-[20px] xl:pt-[40px] pb-[20px] xl:pb-0">
                    <div className="flex gap-[8px]">
                        <div className="w-[2px] h-[18px] bg-[#1E1C21] mt-[6px]"></div>
                        <div className="">
                            <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21]">{t('aboutus.29')}</p>
                            <p className="text-[12px] xl:text-[14px] text-[#000000B2] ibm-plex xl:max-w-[540px] mt-[12px]">{t('aboutus.30')}</p>
                        </div>
                    </div>
                </div>
                <div className="h-[177px] bg-[#F1F1F1] border-[#B8B6B8] border mt-[-1px] px-[20px] pt-[20px] xl:pt-[40px] pb-[20px] xl:pb-0">
                    <div className="flex gap-[8px]">
                        <div className="w-[2px] h-[18px] bg-[#1E1C21] mt-[6px]"></div>
                        <div className="">
                            <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21]">{t('aboutus.33')}</p>
                            <p className="text-[12px] xl:text-[14px] text-[#000000B2] ibm-plex xl:max-w-[540px] mt-[12px]">{t('aboutus.34')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
}

export default YourData;
